export default {
  business: {
    businessName: '',
    businessAddress: '',
    businessTel: ''
  },
  jobAddress: {
    jobName: '',
    jobAddress: '',
    jobTel: ''
  },
  landlordAgent: {
    landlordName: '',
    landlordAddress: '',
    landlordTel: ''
  },
  vesselDetails: {
    make: '',
    model: '',
    location: '',
    makersWarningLabel: '',
    scaleReducerFitted: '',
    capacity: ''
  },
  heatSource: {
    heatSourceType: '',
    gasBoilerType: ''
  },
  installing: {
    inletWaterPressureFlowRate: ''
  },
  commissioning: {
    fullyCommissioned: ''
  },
  operatingDetails1: {
    systemOperatingPressure: '',
    operatingPressureExpansionVessel: '',
    operatingPressureExpansionValve: '',
    operatingTempReliefValve: '',
    maxPrimaryCircuitPressureFlow: ''
  },
  operatingDetails2: {
    nominalSizeD1: '',
    lengthD1: '',
    numberOfDischarges: '',
    sizeOfManifold: '',
    tundishSameLocation: '',
    tundishVisible: '',
    automaticMeansIdentifying: ''
  },
  dischargePipework: {
    nominalSizeD2: '',
    pipeworkMaterial: '',
    pipeworkMinVerticalLength: '',
    pipeworkFallContinuously: '',
    methodOfTermination: '',
    terminationSatisfactory: ''
  },
  defects: {
    defectsIdentified: ''
  },
  workCarriedOut: {
    workCarriedOut: ''
  },
  receivedBy: {
    receivedByName: '',
    receivedByDate: ''
  },
  issuedBy: {
    engineerSignature: '',
    issuedByDate: ''
  }
};
